import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-gray-50 dark:bg-gray-800 py-3 px-0 sm:px-4 my-2 md:rounded-2xl md:shadow-xs"
}
const _hoisted_2 = { class: "p-3" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "text-3xl sm:text-4xl font-bold titleFont" }
const _hoisted_5 = { class: "transition duration-150 text-gray-300 text-3xl hover:text-yellow-300" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "border-t-4 border-t-gray-200 dark:border-t-gray-900 rounded-lg my-3" }, null, -1)
const _hoisted_7 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserProfile = _resolveComponent("UserProfile")!
  const _component_StarIcon = _resolveComponent("StarIcon")!
  const _component_Tippy = _resolveComponent("Tippy")!

  return (_ctx.q)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_UserProfile, {
          user: _ctx.q.user,
          posted_at: _ctx.q.created_at,
          is_anonymous: _ctx.q.is_anonymous
        }, null, 8, ["user", "posted_at", "is_anonymous"]),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.q.image)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.$cdn(_ctx.q.image),
                alt: _ctx.q.title,
                class: "rounded my-2 shadow-sm"
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("h3", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.q.title) + " ", 1),
            _createVNode(_component_Tippy, { content: "Add to favorites" }, {
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_5, [
                  _createVNode(_component_StarIcon)
                ])
              ]),
              _: 1
            })
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}